<div class="row">
    <div class="col-24">
        <h2 class="head2-small">Terms of Enrollment</h2>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p>
            <strong>By completing this enrollment application, I agree to the following:</strong>
        </p>
        <p>
            {{orgName}} offers two Medicare drug plans and has a contract with the Federal government. I understand that this prescription drug coverage is in addition to my coverage under Medicare; therefore, I will need to keep my Medicare Part A or Part B coverage. It is my responsibility to inform {{orgName}} of any prescription drug coverage that I have or may get in the future. I can only be in one Medicare prescription drug plan at a time – if I am currently in a Medicare prescription drug plan, my enrollment in {{orgName}} will end that enrollment. Enrollment in this plan is generally for the entire year. Once I enroll, I may leave this plan or make changes if an enrollment period is available, generally during the Annual Enrollment period (October 15 – December 7), unless I qualify for certain special circumstances.
        </p>
        <p>
            {{orgName}} serves a specific service area. If I move out of the area that {{orgName}} serves, I need to notify the plan so I can disenroll and find a new plan in my new area. I understand that I must use network pharmacies, except in an emergency when I cannot reasonably use {{orgName}} network pharmacies. Once I am a member of {{orgName}}, I have the right to appeal plan decisions about payment or services if I disagree. I will read the Evidence of Coverage document from {{orgName}} when I get it to know which rules I must follow to get coverage.
        </p>
        <p>
            I understand that if I leave this plan and don’t have or get other Medicare prescription drug coverage or creditable prescription drug coverage (as good as Medicare’s), I may have to pay a late enrollment penalty in addition to my premium for Medicare prescription drug coverage in the future.
        </p>
        <p>
            I understand that if I am getting assistance from a sales agent, broker, or other individual employed by or contracted with {{orgName}}, he/she may be paid based on my enrollment in {{orgName}}. Counseling services may be available in my state to provide advice concerning Medicare supplement insurance or other Medicare Advantage or Prescription Drug Plan options, medical assistance through the state Medicaid program and the Medicare Savings Program.
        </p>
    </div>
</div>

<div class="row">
    <div class="col-24">
        <h2 class="head2-small">Release of Information</h2>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <p>
            By joining this Medicare Prescription Drug Plan, I acknowledge that {{orgName}} will release my information to Medicare and other plans as is necessary for treatment, payment and health care operations. I also acknowledge that {{orgName}} will release my information, including my prescription drug event data, to Medicare, who may release it for research and other purposes which follow all applicable federal statutes and regulations. The information on this enrollment form is correct to the best of my knowledge. I understand that if I intentionally provide false information on this form, I will be disenrolled from the plan.
        </p>
        <p>
            I understand that my signature (or the signature of the person authorized to act on my behalf under State law where I live) on this application means that I have read and understand the contents of this application. If signed by an authorized individual (as described above), this signature certifies that:

            1) this person is authorized under State law to complete this enrollment and
            2) documentation of this authority is available upon request by {{orgName}} or by Medicare.

        </p>
    </div>
</div>
<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <ValidatedCheckbox [label]="'Beneficiary has signed application'"
                               [checked]="'false'"
                               (onValueChange)="'valueChanged($emit)'">
            </ValidatedCheckbox>
        </div>
    </div>
</div>
<!--<ValidatedCheckbox [id]="benesigned"
                   [label]=""
                   [checked]="false"
                   (onValueChange)="valueChanged($emit)">
</ValidatedCheckbox>-->
<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <ValidatedRadioButtonGroup [label]="'Does the Applicant have a legal guardian that is authorized to speak on his/her behalf?(Note: The Authorized Representative is NOT the Insurance Agent it is a person who has the power of attorney for the Applicant.)'"
                                       [options]="'poaOptions'"
                                       [selectedValue]="'poaOption'"
                                       [radioGroupName]="'poaOptions'"
                                       (onValueChange)="powOptionChanged($event)">

            </ValidatedRadioButtonGroup>
        </div>
    </div>
</div>

<div *ngIf="showPoaForm">
    <PowerOfAttorneyForm [powerOfAttorneyModel]="'powerOfAttorney'">
    </PowerOfAttorneyForm>
</div>

<div class="row">
    <div class="col-16">
        <div class="bottom-20">
            <p><strong>By clicking the button below, the applicant certifies that the applicant has read, understands and agrees to the terms of enrollment and wishes to enroll with {{orgName}}</strong></p>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-24">
        <button class="button primary" (click)="validateForm()">Continue</button>
    </div>
</div>


